import { isPolicyAddedViaShopInsurance } from '@client/util/policyFundingSourceUtils';

/**
 * Calculate total premium cost for all shop-added policies
 */
export function calculateTotalPolicyPremiumCost(
  multipleFundingSources?: MultipleFundingSources,
): number {
  const policies = multipleFundingSources?.ltcPolicy || {};

  return Object.values(policies).reduce((sum, policy) => {
    if (!isPolicyAddedViaShopInsurance(policy)) return sum;
    return sum + (policy.policyTotalCost || 0);
  }, 0);
}

/**
 * Calculate total existing assets value across all self-funding sources
 */
export function calculateTotalExistingAssetsValue(
  multipleFundingSources?: MultipleFundingSources,
): number {
  const selfFunding = multipleFundingSources?.selfFunding || {};

  return Object.values(selfFunding).reduce((sum, source) => {
    if (source.isDeactivated) return sum;
    return sum + (source.existingAssetsValue || 0);
  }, 0);
}

/**
 * Check if existing assets value is sufficient to cover policy premiums
 */
export function isFundingSufficient(multipleFundingSources?: MultipleFundingSources): boolean {
  const totalPremiumCost = calculateTotalPolicyPremiumCost(multipleFundingSources);
  const totalExistingAssetsValue = calculateTotalExistingAssetsValue(multipleFundingSources);

  return totalExistingAssetsValue >= totalPremiumCost;
}
